<template>
	<div id="app" ref="app">
		<!-- <watermark isShowMark> -->
		<router-view />
		<loading></loading>
		<!-- <freeUserTips></freeUserTips> -->
		<tipspop></tipspop>
		<rightNav></rightNav>
		<!-- 	<v-tour :steps="steps" :enabled="enabled"></v-tour> -->
		<!-- <v-tour name="searchData" :steps="searchDataStep" :options="driverOptions" :callbacks="driverCallbacks"></v-tour> -->
		<!-- <button @click="startTour" style="width: 120px;height: 36px;position: fixed;left: 280px;top: 5px;background: #f30;z-index: 110;">开始引导{{enabled}}</button> -->
		<div class="returnTop" title="返回顶部" @click="returnTop()" v-show="scrollLong > 100"><span
				class="returnTopImg"></span></div>
		<!-- </watermark> -->
	</div>
</template>
<script>

export default {
	name: 'app',
	data() {
		return {
			num: 1,
			demonstrate: this.$api.demonstrate(),
			scrollLong: 100,
			/** 
			driverOptions: {
				useKeyboardNavigation: false, // 是否可用键盘来控制前进后退
				labels: {
					buttonSkip: '跳过',
					buttonPrevious: '上一步',
					buttonNext: '下一步',
					buttonStop: '完成'
				},
				highlight: true // 高亮
			},
			driverCallbacks: {
				onStart: this.driverStart, // 在您开始游览时调用
				onFinish: this.driverStop, //停止游览时调用
			},
			searchDataStep: [{
					target: '#testbox',
					params: {
						placement: 'left'
					},
					content: '点击数据查询',
					before: type => new Promise((resolve, reject) => {
						console.log('每一步执行前', type)
						this.stepBefore()
						resolve('foo')
					})
				},
				{
					target: '.search-box',
					header: {
						title: '查询条件',
					},
					params: {
						placement: 'left'
					},
					content: '选择对应数据的查询条件，进行搜索。',
					before: type => new Promise((resolve, reject) => {
						this.stepBefore()
						resolve('foo')
					})
				},
			],

			enabled: false,
			steps: [{
					target: '#testbox', // 需要引导的目标元素的 CSS 选择器
					content: '这是第一步引导', // 引导内容
					placement: 'top' // 引导页对齐方式 
				},
				{
					target: '.search-box',
					content: '这是第二步引导'
				}
			],**/
		}
	},
	beforeCreate() {

	},
	mounted() {
		var _this = this;
		window.addEventListener("scroll", function () {
			_this.scrollLong = document.documentElement.scrollTop;
		}, true);

	},
	methods: {
		/**
		guideClick() {
			this.guideListShow = false; // 隐藏分布指引类别
			this.$tours['searchData'].start()
		},
		stepBefore() {
			// 获取dom id
			let tours = this.$tours['searchData']
			let currentStep = tours.steps[tours.currentStep + 1]
			let id = currentStep.target
			this.domId = id
		},
		driverStart() {
			console.log('开始')
		},
		driverStop() {
			console.log('结束')
			this.guideListShow = true
		},
		startTour() {
			this.enabled = true;
		},**/
		returnTop() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth"
			});
		}
	},
}
</script>

<style>
@import url("css/index.css");
@import url("css/user.css");
@import url("css/baseC.css");
@import url("css/common.css");
@import url("css/index-continue.css");
@import url("css/dataswiper.css");
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #333;
	width: 100%;
	min-height: 100%;
	background: #F0F3F5 !important;
}

.returnTop {
	position: fixed;
	right: 11px;
	bottom: 50px;
	background: #fff;
	width: 52px;
	height: 40px;
	border: 1px solid #ddd;
	cursor: pointer;
	border-right: none;
	border-radius: 6px 0 0 6px;
	box-shadow: -2px 1px 5px rgba(0, 0, 0, .2);
}

.returnTop .returnTopImg {
	display: block;
	width: 24px;
	height: 24px;
	margin: 10px auto 6px;
	background-image: url(assets/images/returnTop.png);
	background-size: 100% 100%;
}

.returnTop:hover {
	background: #5e83cc;
}

.returnTop:hover .returnTopImg {
	background-image: url(assets/images/returnTopW.png);
}
</style>